import React from 'react';
import { Select, ErrorText } from '../libCategoria';
import { useProfessionalsDropdown } from '../../hooks/useProfesionalesDropdown';

const SelectProfesional = React.forwardRef((props, ref) => {
  const { name, label, defaultValue, error, onChange, ...rest } = props;
  const { professionals } = useProfessionalsDropdown();

  return (
    <div>
      <Select name={name} ref={ref} defaultValue={defaultValue || ''} onChange={onChange} {...rest}>
        <option value="" disabled hidden>Selecciona un profesional...</option>
        {professionals.map((p) => (
          <option key={p.public_id} value={p.public_id}>
            {p.lastname} {p.firstname}
          </option>
        ))}
      </Select>
      {error && <ErrorText>{error}</ErrorText>}
    </div>
  );
});

export default SelectProfesional;
